import { Button, Col, Layout, message, Row, Tooltip, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks/hooks';
import { userSubMenu } from '../../../utils/functions';
import Navbar from '../../Organisms/Navbar/Navbar';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import './RegisterTemplate.less';
import UploadFiles from '../../Atoms/UploadFiles/UploadFiles';
import SectionIndicator, {
  subsections,
} from '../../Molecules/SectionIndicator/SectionIndicator';
import { ReactComponent as Excel } from '../../../res/svg/file-excel-green.svg';
import {
  uploadRegistroPM,
  uploadRegistroDJA,
  getLastRegistro,
  getLastDatesRegistros,
} from '../../../store/slice/importadorXlsxSlice';
import { useEffect, useState } from 'react';
import { ILastDatesRegistros } from '../../../store/services/importadorXlsx/importadorXlsx.service';
import moment from 'moment';
/**
 * @page RegisterTemplate.tsx
 * @description RegisterTemplate.
 * @return { Template }
 */
function RegisterTemplate() {
  const { Text } = Typography;
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const itemsCallback = (item: string) => {
    userSubMenu(item, navigate, dispatch);
  };

  const [disabledButtonDJA, setDisabledButtonDJA] = useState<boolean>(false);
  const [disabledButtonPM, setDisabledButtonPM] = useState<boolean>(false);
  const [lastDatesRegistros, setLastDatesRegistros] =
    useState<ILastDatesRegistros>({ lastDjaDate: null, lastRpmDate: null });
  //@ts-ignore
  const currentUser: User = JSON.parse(localStorage.getItem('currentUser'));

  const permissionUploadRegister = () => {
    if (!currentUser.accesoRegistros) {
      navigate('dashboard');
    }
  };

  const fetchLastDatesRegistros = async () => {
    const value: any = await dispatch(getLastDatesRegistros());
    if (value.payload.status) {
      setLastDatesRegistros(value.payload.data);
    }
  };

  useEffect(() => {
    permissionUploadRegister();
    fetchLastDatesRegistros();
  }, []);

  const uploadDJA = async (options: any) => {
    const { onSuccess, onError, file } = options;
    setDisabledButtonDJA(true);
    dispatch(uploadRegistroDJA(file)).then((value: any) => {
      if (value.payload.status) {
        onSuccess('ok');
        setDisabledButtonDJA(false);
      } else {
        onError(value.payload.data.error);
        setDisabledButtonDJA(false);
      }
    });
  };

  const uploadPM = async (options: any) => {
    const { onSuccess, onError, file } = options;
    setDisabledButtonPM(true);
    dispatch(uploadRegistroPM(file)).then((value: any) => {
      if (value.payload.status) {
        onSuccess('ok');
        setDisabledButtonPM(false);
      } else {
        onError(value.payload.data.error);
        setDisabledButtonPM(false);
      }
    });
  };

  const props: UploadProps = {
    onChange(info) {
      if (info.file.status === 'done') {
        message.success(`Archivo subido correctamente`);
      } else if (info.file.status === 'error') {
        message.error(
          `Ocurrió un error al subir el archivo. Por favor intenta nuevamente`,
        );
      }
    },
    accept: '.xlsx',
    showUploadList: {
      showRemoveIcon: false,
    },
  };

  const downloadLastRegistro = (typeRegistro: number) => {
    dispatch(getLastRegistro({ tipo: typeRegistro })).then((value: any) => {
      if (value.payload.status) {
        const url = window.URL.createObjectURL(value.payload.data);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        if (typeRegistro === 0) {
          a.download = `Ultimo_Registro_DJA_${Date.now()}.xlsx`;
        } else if (typeRegistro === 1) {
          a.download = `Ultimo_Registro_PM_${Date.now()}.xlsx`;
        } else {
          return console.error('No existe el archivo');
        }
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } else if (!value.payload.status) {
        message.error('No hay archivos de este tipo subidos al sistema');
      }
    });
  };

  return (
    <Layout>
      <Navbar showItems={false} itemsCallback={itemsCallback} />
      <SectionIndicator subsection={subsections.gestorRegistros} />
      <Layout className="tp-task__layout">
        <Row>
          <Col span={19}>
            <div className={'container-title'}>
              <Excel style={{ paddingRight: '7.5px' }} />
              <div className={'contaier-content-text'}>
                <div className={'ml-section-indicator__section_2'}>
                  Sube aquí tus archivos de Excel.
                </div>
                <div className={'ml-section-indicator__section_1'}>
                  <Text strong style={{ color: '#595959' }}>
                    1.{' '}
                  </Text>{' '}
                  Elige el archivo que quieres subir (Registros de PM o DJA).
                </div>
                <div className={'ml-section-indicator__section_1'}>
                  <Text strong style={{ color: '#595959' }}>
                    2.{' '}
                  </Text>{' '}
                  Recuerda que solo se admiten archivos con extensión .xlsx.
                </div>
                <div className={'ml-section-indicator__section_1'}>
                  <Text strong style={{ color: '#595959' }}>
                    3.{' '}
                  </Text>{' '}
                  Los datos que contengan los archivos que vas a subir
                  actualizarán los existentes.
                </div>
                <div className={'ml-section-indicator__section_1'}>
                  <Text strong style={{ color: '#595959' }}>
                    4.{' '}
                  </Text>{' '}
                  Tener en cuenta que las columnas y sus nombres no deben
                  modificarse ni agruparse.
                </div>
                <div className={'ml-section-indicator__section_1'}>
                  <Text strong style={{ color: '#595959' }}>
                    NOTA:{' '}
                  </Text>{' '}
                  <span style={{ textDecorationLine: 'underline' }}>
                    se debe subir primero el PM y segundo el DJA{' '}
                  </span>
                </div>
              </div>
            </div>
          </Col>
          <Col span={5}>
            <div>
              <div className={'container-button first-button'}>
                <Button
                  type="ghost"
                  className="button-pma"
                  icon={<UploadOutlined />}
                  onClick={() => downloadLastRegistro(1)}
                >
                  Descargar último Registro de PM
                </Button>
                {lastDatesRegistros.lastRpmDate && (
                  <Tooltip title="Fecha y hora de último Registro de PM cargado">
                    <p className="help-text-last-date">
                      Última actualización: {moment(lastDatesRegistros.lastRpmDate).format("DD/MM/YYYY HH:mm")}
                    </p>
                  </Tooltip>
                )}
              </div>
              <div className={'container-button'}>
                <Button
                  type="ghost"
                  className="button-dja"
                  icon={<UploadOutlined />}
                  onClick={() => downloadLastRegistro(0)}
                >
                  Descargar última DJA
                </Button>
                {lastDatesRegistros.lastDjaDate && (
                  <Tooltip title="Fecha y hora de última DJA cargado">
                    <p className="help-text-last-date">
                      Última actualización: {moment(lastDatesRegistros.lastDjaDate).format("DD/MM/YYYY HH:mm")}
                    </p>
                  </Tooltip>
                )}
              </div>
            </div>
          </Col>
        </Row>
        <Row style={{ paddingTop: '100px' }}>
          <Col span={12}>
            <div className={'container-upload'}>
              <UploadFiles
                listType="picture"
                textButton={'SUBIR REGISTRO DE PM'}
                customRequest={uploadPM}
                icon={<UploadOutlined />}
                colorButton={'#0078A0'}
                widthButton={'266px'}
                propsUpload={props}
                typeButton={'primary'}
                disabledButton={disabledButtonPM}
              />
            </div>
          </Col>
          <Col span={12}>
            <div className={'container-upload'}>
              <UploadFiles
                listType="picture"
                customRequest={uploadDJA}
                textButton={'SUBIR DJA'}
                icon={<UploadOutlined />}
                colorButton={'#F3943E'}
                widthButton={'266px'}
                propsUpload={props}
                typeButton={'primary'}
                disabledButton={disabledButtonDJA}
              />
            </div>
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
}

export default RegisterTemplate;
